import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SelectPanelModule } from '../select-panel/select-panel.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { ButtonGroupComponent } from './button-group.component';
import { ButtonGroupOption } from './button-group.type';

@NgModule({
  declarations: [ButtonGroupComponent],
  exports: [ButtonGroupComponent],
  entryComponents: [ButtonGroupComponent],
  imports: [CommonModule, AngularSvgIconModule, FormsModule, TranslateModule, DropdownModule, SelectPanelModule]
})
export class ButtonGroupModule {}

export { ButtonGroupComponent, ButtonGroupOption };
